import React from 'react';
import "./header.css"
const Header = () => {
  return (
  <span className="header" >🧘‍♂️ Admission Form for Yoga classes 🧘‍♂️</span>
  )
};

export default Header
